import { call, put, takeLatest } from 'redux-saga/effects'
import { PointsActions, PointsTypes } from './pointsSlice'
import api from '../../services/api'

function* rewardPointsSaga() {
  const response = yield call(api.rewardPoints)
  if (response.ok) {
    yield put(PointsActions.rewardPointsSuccess(response.data))
  } else {
    yield put(PointsActions.rewardPointsFailure(response.problem))
  }
}

function* rewardPointsHistorySaga(action) {
  const { page, size } = action
  const response = yield call(api.rewardPointsHistory, page, size)
  if (response.ok) {
    yield put(PointsActions.rewardPointsHistorySuccess(response.data))
  } else {
    yield put(PointsActions.rewardPointsHistoryFailure(response.problem))
  }
}

function* redeemPointsSaga() {
  const response = yield call(api.redeemPoints)
  if (response.ok) {
    yield put(PointsActions.redeemPointsSuccess(response.data))
  } else {
    yield put(PointsActions.redeemPointsFailure(response.problem))
  }
}

export default function* pointsSaga() {
  yield takeLatest(PointsTypes.REWARD_POINTS_REQUEST,         rewardPointsSaga)
  yield takeLatest(PointsTypes.REWARD_POINTS_HISTORY_REQUEST, rewardPointsHistorySaga)
  yield takeLatest(PointsTypes.REDEEM_POINTS_REQUEST,         redeemPointsSaga)
}
